import { en } from './en-us';
import { de } from './de-de';

export const messages = {
  'en-us': en,
  'de-de': de
};
